import { ChangeDetectorRef, Component, HostListener, Type, ViewChild } from "@angular/core";
import { isNullOrEmptyString } from "@progress/kendo-angular-grid/dist/es2015/utils";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, Permission, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { InvGoodsKind, RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { GoodsFormulaDetail, GoodsFormulaHeader, GoodsSimilar } from "../../models/goods-formula-detail.model";
import { Goods } from "../../models/goods.model";
import { GoodsFormulaFormComponent } from "./goods-formula-form/goods-formula-form.component";
import { GoodsFormulaViewFormComponent } from "./goods-formula-view-form/goods-formula-view-form.component";
import { GoodsSimilarFormComponent } from "./goods-similar/goods-similar-form.component";

@Component({
  selector: "ngx-goods-formula",
  templateUrl: "./goods-formula.component.html",
  styleUrls: ["./goods-formula.component.scss"],
})
export class GoodsFormulaComponent extends BaseFormComponent<Goods> {
  refresh() {
    this.ngOnInit();
  }
  isloading: boolean = false;
  actions: EntityListAction[];
  analysisActions: EntityListAction[];
  inputEditorform: Type<any>;
  GoodsFormulaDetailsColumns: form_control[];
  GoodsFormulaHeadersColumns: form_control[];
  GoodsSimilarColumns: form_control[];
  @ViewChild("goodsFormulaHeaders") public goodsFormulaHeaders: KGridComponent;
  @ViewChild("goodsFormulaDetail") public goodsFormulaDetail: KGridComponent;

  GoodsFormulaDetails: GoodsFormulaDetail[] = [];
  GoodsSimilars: GoodsSimilar[] = [];
  erroremessage: string;
  DefaultValues: Dictionary = [];
  DetailDefaultValues: Dictionary = [];
  CurrentGoodsFormulaHeader: GoodsFormulaHeader;
  CurrentGoodsFormulaDetail: GoodsFormulaDetail;
  isOkforEdit: boolean = false;
  public headerColumns: form_control[] = [];
  constructor(
    protected selectorService: SelectorService,
    __id: FormContainerModel,
    _tabsservice: TabularService,
    protected cd: ChangeDetectorRef,
    private datatransfer: Datatransfer,
    _VoucherKindInfo: VoucherKindInfo
  ) {
    super(selectorService, cd);
    this._id = __id;
    this.currentrow = this.datatransfer?.currentrow;
    if (this.datatransfer?.apiName) this.apiName = this.datatransfer?.apiName.split("/")[0];
    if (this.datatransfer?.areaName) this.areaName = this.datatransfer?.areaName;
    this.VoucherKind = _VoucherKindInfo;
    this.tabsservice = _tabsservice;
    this.inputEditorform = GoodsFormulaFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
    this.onanalysisActionClick = this.onanalysisActionClick.bind(this);
  }

  async ngOnInit() {
    this.DefaultValues["Active"] = true;
    this.DefaultValues["GoodsId"] = this.currentrow.Id;
    this.DefaultValues["GoodsFormulaDetails"] = [];
    this.DefaultValues["Title"] = this.currentrow.Title;
    this.DefaultValues["GoodsUnitTitle"] = this.currentrow.UnitTitle;
    this.DetailDefaultValues["PriceRatio"] = 1;
    this.DetailDefaultValues["GoodsFormulaDetailId"] = 0;
    this.DetailDefaultValues["Priority"] = 1;

    this.apiName = "Goods";
    this.label = this.currentrow["Title"] ? `اجزاء تشکیل دهنده کالا(${this.currentrow["Title"]})` : "اجزاء تشکیل دهنده کالا";
    if (this.currentrow && this.currentrow["GoodsKindCode"] !== InvGoodsKind.HalfMade && this.currentrow["GoodsKindCode"] !== InvGoodsKind.Product)
      this.erroremessage = "اجزاء تشکیل دهنده فقط برای کالای از نوع محصول یا نیم ساخته امکان پیذیر است ";
    this.setactions();
    await super.ngOnInit();
    this.setHeaderColumns();
    this.setDetailColumns();
    this.setGoodsSimilarColumns();
  }
  @HostListener("window:keydown", ["$event"])
  keyboardBinded(e: KeyboardEvent) {
    if (e.ctrlKey && !e.altKey) {
      if (e.code == "KeyD") {
        e.preventDefault();

        this.goodsFormulaHeaders.copy();
      }
      if (e.code == "KeyR") {
        e.preventDefault();
        this.ngOnInit();
        // this.model.GoodsFormulaHeaders = null;
        // this.goodsFormulaHeaders.loadReports().finally(async () => {
        //   await this.goodsFormulaHeaders.refreshData();
        // });

        // this.goodsFormulaDetail.loadReports().finally(async () => {
        //   this.goodsFormulaDetail.refreshData();
        // });
      }
    }
  }
  onChange($event) {}
  isValid() {
    let flag: boolean = true;
    if (!this.model.GoodsFormulaHeaders || this.model.GoodsFormulaHeaders.length <= 0) {
      this.erroremessage = "هیچ آنالیزی تعریف نشده است.";
      this.sts.showDialog(this.erroremessage, this.translate("MessageHeader.Error"));
      flag = false;
    }
    if (
      flag &&
      this.model.GoodsFormulaHeaders.some(
        (x) => x.State != RowState.Delete && x.State != RowState.Detached && (!x.GoodsFormulaDetails || x.GoodsFormulaDetails.length <= 0)
      )
    ) {
      this.erroremessage = "هیچ کالای برای آنالیزی انتخاب نشده است.";
      this.sts.showDialog(this.erroremessage, this.translate("MessageHeader.Error"));
      flag = false;
    }
    return flag;
  }
  setdefault() {
    if (!this.model.GoodsFormulaHeaders) this.model.GoodsFormulaHeaders = [];
    else this.HeaderRowSelected(this.model.GoodsFormulaHeaders[0]);
    if (this.isNewRow && isNullOrEmptyString(this.model.Title) && this.currentrow) this.model.Title = this.currentrow.Title;
    this.cd.markForCheck();
  }
  onCreateGoodsFormulaHeader($event: GoodsFormulaHeader) {
    $event = <GoodsFormulaHeader>{};
    $event.Active = true;
    $event.EffectDate = new Date();
    $event.GoodsId = this.model.Id;
    $event.GoodsTitle = this.model.Title;
    $event.GoodsCode = this.model.Code;
    $event.Title = this.model.Title;
    $event.GoodsUnitTitle = this.model.UnitTitle;
    $event.TempRowNumber = this.model.GoodsFormulaHeaders.length + 100;
    $event.State = RowState.New;
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: $event,
          _columns: this.GoodsFormulaHeadersColumns,
          areaName: this.areaName,
          label: "آنالیز کالا",
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        if (model) {
          this.model.GoodsFormulaHeaders.push(model as GoodsFormulaHeader);
          this.goodsFormulaHeaders.refreshData();
          this.cd.markForCheck();
        }
      });
  }
  onDeleteGoodsFormulaHeader($event: GoodsFormulaHeader) {
    if (
      $event?.GoodsFormulaDetails &&
      $event.GoodsFormulaDetails.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached) &&
      $event.GoodsFormulaDetails.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).length > 0
    ) {
      this.sts.showDialog("به علت وجود قلم آنالیز امکان حذف نیست.", "حذف آنالیز");
      return;
    } else {
      let temp = this.model.GoodsFormulaHeaders.find(
        (x) => (x.Id && x.Id !== 0 && x.Id === $event.Id) || ($event.TempRowNumber && x.TempRowNumber === $event.TempRowNumber)
      );
      if (temp && temp.State === RowState.New) temp.State = RowState.Detached;
      else temp.State = RowState.Delete;
      this.goodsFormulaHeaders.isRefreshing = true;
      this.goodsFormulaHeaders.refreshData();
      this.cd.markForCheck();
    }
  }
  onEditGoodsFormulaHeader($event) {
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: $event,
          _columns: this.GoodsFormulaHeadersColumns,
          areaName: this.areaName,
          label: "آنالیز کالا",
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        if (model) {
          (model as GoodsFormulaHeader).State = RowState.Modify;
          this.model.GoodsFormulaHeaders.forEach((x) => {
            if ((x.Id && x.Id !== 0 && x.Id === $event.Id) || ($event.TempRowNumber && x.TempRowNumber === $event.TempRowNumber)) {
              Object.assign(x, model);
              this.goodsFormulaHeaders.isRefreshing = true;
              this.goodsFormulaHeaders.refreshData();
              this.cd.markForCheck();
            }
          });
        }
      });
  }
  onCreateGoodsFormulaDetail($event: GoodsFormulaDetail) {
    if (!this.CurrentGoodsFormulaHeader && this.model.GoodsFormulaHeaders.length === 1)
      this.CurrentGoodsFormulaHeader = this.model.GoodsFormulaHeaders[0];

    if (!this.CurrentGoodsFormulaHeader) this.sts.showDialog("آنالیز انتخاب نشده است.", "");
    if (!this.CurrentGoodsFormulaHeader.GoodsFormulaDetails) this.CurrentGoodsFormulaHeader.GoodsFormulaDetails = [];
    if (!this.GoodsFormulaDetails) this.GoodsFormulaDetails = [];
    $event = <GoodsFormulaDetail>{};
    $event.GoodsFormulaHeaderId = this.CurrentGoodsFormulaHeader.Id ?? 0;
    $event.PriceRatio = 1;
    $event.LossPercent = 0;
    $event.LossAmount = 0;
    $event.Id = this.model.Id;
    $event.TempRowNumber = this.GoodsFormulaDetails.length + 100;
    $event.State = RowState.New;
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: $event,
          _columns: this.GoodsFormulaDetailsColumns,
          areaName: this.areaName,
          label: "اجزاء تشکیل دهنده کالا",
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        if (model) {
          if (this.model.GoodsFormulaHeaders.some((s) => s.GoodsId === model["GoodsId"])) {
            this.sts.showDialog(`محصول اصلی (${model["GoodsTitle"]})  نمی تواند به عنوان مواد انتخاب شود.`, "خطای انتخاب کالا");
            return;
          }
          this.model.GoodsFormulaHeaders.forEach((x) => {
            if (
              (x.TempRowNumber && x.TempRowNumber === this.CurrentGoodsFormulaHeader.TempRowNumber) ||
              (x.Id && x.Id !== 0 && x.Id === this.CurrentGoodsFormulaHeader.Id)
            ) {
              if (!x.GoodsFormulaDetails) x.GoodsFormulaDetails = [];
              x.GoodsFormulaDetails.push(model as GoodsFormulaDetail);
              this.GoodsFormulaDetails = x.GoodsFormulaDetails;
              this.goodsFormulaDetail.isRefreshing = true;
              this.goodsFormulaDetail.refreshData();
              this.cd.markForCheck();
            }
          });
        }
      });
  }
  onDeleteGoodsFormulaDetail($event: GoodsFormulaDetail) {
    if (
      $event?.GoodsSimilars &&
      $event.GoodsSimilars.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached) &&
      $event.GoodsSimilars.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).length > 0
    ) {
      this.sts.showDialog("به علت وجود کالا مشابه امکان حذف نیست.", "حذف قلم آنالیز");
    } else {
      this.model.GoodsFormulaHeaders.forEach((gfh) => {
        gfh.GoodsFormulaDetails.forEach((gfd) => {
          if (($event.TempRowNumber && gfd.TempRowNumber === $event.TempRowNumber) || (gfd.Id && gfd.Id !== 0 && gfd.Id === $event.Id)) {
            if (gfd.State === RowState.New) gfd.State = RowState.Detached;
            else gfd.State = RowState.Delete;
            this.goodsFormulaDetail.isRefreshing = true;
            this.goodsFormulaDetail.refreshData();
            this.cd.markForCheck();
          }
        });
      });
    }
  }
  onEditGoodsFormulaDetail($event) {
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: $event,
          _columns: this.GoodsFormulaDetailsColumns,
          areaName: this.areaName,
          label: "اجزاء تشکیل دهنده کالا",
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        if (model) {
          if (this.model.GoodsFormulaHeaders.some((s) => s.GoodsId === model["GoodsId"])) {
            this.sts.showDialog(`محصول اصلی (${model["GoodsTitle"]})  نمی تواند به عنوان مواد انتخاب شود.`, "خطای انتخاب کالا");
            return;
          }
          (model as GoodsFormulaDetail).State = RowState.Modify;
          (model as GoodsFormulaDetail).LossAmount = ((model as GoodsFormulaDetail).StandardAmount * (model as GoodsFormulaDetail).LossPercent) / 100;
          this.model.GoodsFormulaHeaders.forEach((x) =>
            x.GoodsFormulaDetails.forEach((gfd) => {
              if ((gfd.TempRowNumber && gfd.TempRowNumber === $event.TempRowNumber) || (gfd.Id && gfd.Id !== 0 && gfd.Id === $event.Id)) {
                Object.assign(gfd, model);
                this.goodsFormulaDetail.isRefreshing = true;
                this.goodsFormulaDetail.refreshData();
                this.cd.markForCheck();
              }
            })
          );
        }
      });
  }

  beforupdate() {
    if (this.CurrentGoodsFormulaHeader != undefined) {
      this.HeaderRowSelected(this.CurrentGoodsFormulaHeader);
    } else if (this.CurrentGoodsFormulaDetail !== undefined) {
      this.DetailRowSelected(this.CurrentGoodsFormulaDetail);
    }
    if (this.model.GoodsFormulaHeaders && this.model.GoodsFormulaHeaders.length > 0) {
      this.model.GoodsFormulaHeaders.forEach((h) => {
        if (h.GoodsFormulaDetails && this.model.GoodsFormulaHeaders.length <= 0) h.GoodsFormulaDetails = undefined;
        else if (h.GoodsFormulaDetails)
          h.GoodsFormulaDetails.forEach((d) => {
            if (d.GoodsSimilars && d.GoodsSimilars.length <= 0) d.GoodsSimilars = undefined;
          });
      });
    }
  }
  HeaderRowSelected(event: GoodsFormulaHeader) {
    if (event) {
      this.CurrentGoodsFormulaHeader = event;
      this.GoodsFormulaDetails = event.GoodsFormulaDetails;
      this.setRowIndex();
      this.isOkforEdit = this.GoodsFormulaDetails && this.GoodsFormulaDetails.length > 0;
      if (this.goodsFormulaDetail) {
        this.goodsFormulaDetail.isRefreshing = true;
        this.goodsFormulaDetail.refreshData();
        this.goodsFormulaDetail.isRefreshing = false;
      }
    }
  }
  DetailRowSelected(event: GoodsFormulaDetail) {
    if (event) {
      this.CurrentGoodsFormulaDetail = event;
      this.GoodsSimilars = event.GoodsSimilars;
      this.isOkforEdit = this.GoodsSimilars && this.GoodsSimilars.length > 0;
    }
  }
  setHeaderColumns() {
    this.GoodsFormulaHeadersColumns = [];
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsId",
      textType: "number",
      disabled: false,
      name: "GoodsId",
      order: 0,
      formVisible: false,
      listVisible: false,
      required: true,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "کد کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsCode",
      disabled: true,
      name: "GoodsCode",
      textType: "text",
      order: 1,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "عنوان کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsTitle",
      disabled: true,
      name: "GoodsTitle",
      textType: "text",
      order: 2,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "عنوان",
      controlType: FormControlTypes.textbox,
      modelName: "Title",
      textType: "text",
      disabled: false,
      name: "Title",
      order: 3,
      formVisible: true,
      listVisible: true,
      required: true,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "واحد سنجش",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsUnitTitle",
      textType: "text",
      disabled: true,
      name: "GoodsUnitTitle",
      order: 4,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "مقدار",
      controlType: FormControlTypes.textbox,
      modelName: "Amount",
      textType: "number",
      disabled: false,
      name: "Amount",
      order: 5,
      formVisible: true,
      listVisible: true,
      required: true,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "تاریخ موثر",
      controlType: FormControlTypes.datePicker,
      modelName: "EffectDate",
      disabled: false,
      name: "EffectDate",
      textType: "date",
      order: 6,
      formVisible: true,
      listVisible: false,
      required: false,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "تاریخ موثر",
      controlType: FormControlTypes.textbox,
      modelName: "ShamsiEffectDate",
      disabled: false,
      name: "ShamsiEffectDate",
      textType: "date",
      order: 6,
      formVisible: false,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "توضیحات",
      controlType: FormControlTypes.textbox,
      modelName: "Comment",
      disabled: false,
      name: "Comment",
      textType: "text",
      order: 7,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "شعبه",
      controlType: FormControlTypes.dropdown,
      modelName: "BranchId",
      disabled: false,
      name: "BranchId",
      textType: "text",
      order: 8,
      formVisible: true,
      listVisible: true,
      required: false,
      apiName: "Branch/ReadLookUp",
      valueMember: "Id",
      displayMember: "Title",
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "فعال",
      controlType: FormControlTypes.checkbox,
      modelName: "Active",
      disabled: false,
      name: "Active",
      textType: "checkbox",
      order: 9,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "انبار رستورانی",
      controlType: FormControlTypes.checkbox,
      modelName: "IsResuarantWareHouse",
      disabled: false,
      name: "IsResuarantWareHouse",
      textType: "checkbox",
      order: 10,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "قیمت تمام شده",
      controlType: FormControlTypes.textbox,
      modelName: "CostPrice",
      disabled: false,
      name: "CostPrice",
      textType: "currency",
      order: 11,
      formVisible: false,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaHeadersColumns.push(<form_control>{
      label: "اقلام آنالیز",
      controlType: FormControlTypes.dropdown,
      modelName: "GoodsFormulaDetails",
      disabled: false,
      name: "GoodsFormulaDetails",
      textType: "text",
      order: 11,
      formVisible: false,
      listVisible: false,
      required: false,
    });
  }
  setDetailColumns() {
    this.GoodsFormulaDetailsColumns = [];
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "فرمول",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsFormulaHeaderId",
      textType: "number",
      disabled: false,
      name: "GoodsFormulaHeaderId",
      order: 0,
      formVisible: false,
      listVisible: false,
      required: false,
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "کالا",
      controlType: FormControlTypes.lookup,
      modelName: "GoodsId",
      textType: "text",
      disabled: false,
      name: "GoodsId",
      order: 1,
      formVisible: true,
      listVisible: false,
      required: true,
      apiName: "Goods/GetPagining",
      valueMember: "Id",
      displayMember: "Title",
      columnsName: "GoodsKindCode,GoodsKindTitle,GoodsGroupTreePath,Code,Title,UnitTitle",
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "ردیف",
      modelName: "RowNumber",
      disabled: false,
      name: "RowNumber",
      textType: "text",
      order: 2,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "کد کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsCode",
      disabled: false,
      name: "GoodsCode",
      textType: "text",
      order: 2,
      formVisible: false,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "عنوان کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsTitle",
      disabled: false,
      name: "GoodsTitle",
      textType: "text",
      order: 3,
      formVisible: false,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "کد نوع کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsKindCode",
      disabled: false,
      name: "GoodsKindCode",
      textType: "text",
      order: 3,
      formVisible: false,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "عنوان نوع کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsKindTitle",
      disabled: false,
      name: "GoodsKindTitle",
      textType: "text",
      order: 3,
      formVisible: false,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "واحد سنجش",
      controlType: FormControlTypes.textbox,
      modelName: "UnitTitle",
      textType: "text",
      disabled: true,
      name: "UnitTitle",
      order: 4,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "مقدار استاندارد",
      controlType: FormControlTypes.textbox,
      modelName: "StandardAmount",
      textType: "number",
      disabled: false,
      name: "StandardAmount",
      order: 5,
      formVisible: true,
      listVisible: true,
      required: true,
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "درصد ضایعات",
      controlType: FormControlTypes.textbox,
      modelName: "LossPercent",
      disabled: false,
      name: "LossPercent",
      textType: "number",
      order: 6,
      formVisible: false,
      listVisible: false,
      required: false,
      max: 100,
      min: 0,
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "مقدار ضایعات",
      controlType: FormControlTypes.textbox,
      modelName: "LossAmount",
      disabled: false,
      name: "LossAmount",
      textType: "number",
      order: 7,
      formVisible: false,
      listVisible: false,
      required: false,
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "ضریب قیمت",
      controlType: FormControlTypes.textbox,
      modelName: "PriceRatio",
      disabled: false,
      name: "PriceRatio",
      textType: "number",
      order: 8,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsFormulaDetailsColumns.push(<form_control>{
      label: "توضیحات",
      controlType: FormControlTypes.textbox,
      modelName: "Comment",
      disabled: false,
      name: "Comment",
      textType: "text",
      order: 9,
      formVisible: true,
      listVisible: true,
      required: false,
      maxLength: 255,
    });
  }
  setGoodsSimilarColumns() {
    this.GoodsSimilarColumns = [];
    this.GoodsSimilarColumns.push(<form_control>{
      label: "فرمولاجزاء تشکلیل دهنده کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsFormulaDetailId",
      textType: "number",
      disabled: false,
      name: "GoodsFormulaDetailId",
      order: 0,
      formVisible: false,
      listVisible: false,
      required: true,
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "کالا",
      controlType: FormControlTypes.lookup,
      modelName: "GoodsId",
      textType: "text",
      disabled: false,
      name: "GoodsId",
      order: 1,
      formVisible: true,
      listVisible: false,
      required: true,
      apiName: "Goods/GetPagining",
      valueMember: "Id",
      displayMember: "Title",
      columnsName: "GoodsGroupTreePath,Code,Title,UnitTitle",
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "کد کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsCode",
      disabled: false,
      name: "GoodsCode",
      textType: "text",
      order: 2,
      formVisible: false,
      listVisible: true,
      required: false,
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "عنوان کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsTitle",
      disabled: false,
      name: "GoodsTitle",
      textType: "text",
      order: 3,
      formVisible: false,
      listVisible: true,
      required: false,
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "کد نوع کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsKindCode",
      disabled: false,
      name: "GoodsKindCode",
      textType: "text",
      order: 3,
      formVisible: false,
      listVisible: true,
      required: false,
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "عنوان نوع کالا",
      controlType: FormControlTypes.textbox,
      modelName: "GoodsKindTitle",
      disabled: false,
      name: "GoodsKindTitle",
      textType: "text",
      order: 3,
      formVisible: false,
      listVisible: true,
      required: false,
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "واحد سنجش",
      controlType: FormControlTypes.textbox,
      modelName: "UnitTitle",
      textType: "text",
      disabled: true,
      name: "UnitTitle",
      order: 4,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "مقدار استاندارد",
      controlType: FormControlTypes.textbox,
      modelName: "StandardAmount",
      textType: "number",
      disabled: false,
      name: "StandardAmount",
      order: 5,
      formVisible: true,
      listVisible: true,
      required: true,
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "درصد ضایعات",
      controlType: FormControlTypes.textbox,
      modelName: "LossPercent",
      disabled: false,
      name: "LossPercent",
      textType: "number",
      order: 5,
      formVisible: false,
      listVisible: false,
      required: false,
      max: 100,
      min: 0,
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "مقدار ضایعات",
      controlType: FormControlTypes.textbox,
      modelName: "LossAmount",
      disabled: false,
      name: "LossAmount",
      textType: "number",
      order: 6,
      formVisible: false,
      listVisible: false,
      required: false,
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "ضریب قیمت",
      controlType: FormControlTypes.textbox,
      modelName: "PriceRatio",
      disabled: false,
      name: "PriceRatio",
      textType: "number",
      order: 7,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "الویت",
      controlType: FormControlTypes.textbox,
      modelName: "Priority",
      disabled: false,
      name: "Priority",
      textType: "number",
      order: 8,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.GoodsSimilarColumns.push(<form_control>{
      label: "توضیحات",
      controlType: FormControlTypes.textbox,
      modelName: "Comment",
      disabled: false,
      name: "Comment",
      textType: "text",
      order: 9,
      formVisible: true,
      listVisible: true,
      required: false,
      maxLength: 255,
    });
  }

  setactions() {
    this.actions = [
      {
        name: "GoodsSimilar",
        disabled: false,
        displayName: "کالای مشابه",
        iconName: "icon-content-copy",
        apiName: "Goods/GetGoodsFormula",
        areaName: "Inventory",
        requireSelectedrows: true,
        Form_Component: GoodsSimilarFormComponent,
        permission: Permission.viewPermission,
      },
      {
        name: "GetGoodsFormula",
        disabled: false,
        displayName: "اجزاء تشکیل دهنده کالا",
        iconName: "icon-pie_chart-o",
        apiName: "Goods/GetGoodsFormula",
        areaName: "Inventory",
        requireSelectedrows: true,
        Form_Component: GoodsFormulaViewFormComponent,
        permission: Permission.viewPermission,
      },
    ];
    this.analysisActions = [
      {
        name: "GetCostPrice",
        disabled: false,
        displayName: "گرفتن قیمت تمام شده",
        iconName: "icon-request_quote-F",
        apiName: "Goods/GetCostPrice",
        areaName: "Inventory",
        permission: Permission.viewPermission,
      },
    ];
  }
  onActionClick(action: EntityListAction, onRowSelected: Goods, onRowsSelected: Goods[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    ///کالای تولید / نیم ساخته
    if (
      action.name === "GetGoodsFormula" &&
      onRowSelected &&
      onRowSelected.GoodsKindCode !== InvGoodsKind.Product &&
      onRowSelected.GoodsKindCode !== InvGoodsKind.HalfMade
    ) {
      this.sts.showDialog("فقط کالا از نوع محصول /نیم ساخته قابل انتخاب است.", "");
    }
    ///اجزاء تشکیل دهنده کالا
    else if (action.name === "GetGoodsFormula") {
      this.dialogService
        .open(
          action.Form_Component,
          {
            currentrow: onRowSelected,
            apiName: action.apiName,
            areaName: action.areaName,
            GoodsFormulaDetailsColumns: this.GoodsFormulaDetailsColumns,
            label: "اجزاء تشکیل دهنده کالا",
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {});
    }
    ///کالای مشابه
    if (action.name === "GoodsSimilar") {
      this.dialogService
        .open(
          action.Form_Component,
          {
            currentrow: this.model,
            apiName: action.apiName,
            areaName: action.areaName,
            GoodsSimilarColumns: this.GoodsSimilarColumns,
            CurrentGoodsFormulaDetail: this.CurrentGoodsFormulaDetail,
            CurrentGoodsFormulaHeader: this.CurrentGoodsFormulaHeader,
            GoodsSimilars: this.GoodsSimilars,
            label: `کالای مشابه (${this.CurrentGoodsFormulaDetail?.GoodsTitle})`,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {});
    }
  }

  ShowList() {
    // this.dialogService
    //   .open(InvDailyListDialogComponent as any, { closeOnClickOutside: true })
    //   .pipe(takeUntil(this.ngUnsubscribe))
    //   .subscribe((details: InvDailyDetail[]) => {
    //     if (details?.length) {
    //       this.model.InvDailyDetails = details;
    //       this.cd.markForCheck();
    //     }
    //   });
  }
  onanalysisActionClick(action: EntityListAction, onRowSelected: any, onRowsSelected: any[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    if (action.name === "GetCostPrice") {
      this.httpCommonService.getList(`Goods/GetCostPrice/${this.model.Id}`).subscribe((res: any[]) => {
        if (res?.length > 0) {
          this.model.GoodsFormulaHeaders.forEach((header: any) => {
            const findItem = res.find((f) => f.GoodsFormulaHeaderId === header.Id);
            header.CostPrice = findItem?.UnitPrice;
          });
        }
      });
    }
  }

  setRowIndex() {
    this.GoodsFormulaDetails.forEach((it, index) => {
      it.RowNumber = index + 1;
    });
  }

  copy(event: GoodsFormulaHeader) {
    event.Id = (this.goodsFormulaHeaders.gridView.data.pop() as GoodsFormulaHeader).Id + 1;
    event.GoodsFormulaDetails.map((it) => (it.GoodsFormulaHeaderId = event.Id));
  }
}
